import React, { CSSProperties, FC } from 'react'

export const GearWheelSvg: FC<{ style?: CSSProperties }> = ({ style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    style={style}
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#46AAE9"
        strokeWidth="1.5"
        d="M19.9848878,12.0006162 C19.9848878,16.4102363 16.4096201,19.985504 12,19.985504 C7.5903799,19.985504 4.01387975,16.4102363 4.01387975,12.0006162 C4.01387975,7.59099611 7.5903799,4.01449597 12,4.01449597 C16.4096201,4.01449597 19.9848878,7.59099611 19.9848878,12.0006162 L19.9848878,12.0006162 Z"
      />
      <path
        stroke="#46AAE9"
        strokeWidth="2.1"
        d="M19.5917439 9.53329943L22.8416512 8.47711038 19.5917439 9.53329943zM1.1583488 15.5228896L4.40209393 14.4691654 1.1583488 15.5228896zM19.6016033 14.4703978L22.8416512 15.5228896 19.6016033 14.4703978zM1.1583488 8.47711038L4.40455878 9.53206701 1.1583488 8.47711038zM16.6906132 18.4560634L18.7007 21.2228597 16.6906132 18.4560634zM5.30053246 2.7771403L7.31308406 5.54886629 5.30053246 2.7771403zM12 19.985504L12 23.399324 12 19.985504zM12.0012324.600676048L12.0012324 4.01449597 12.0012324.600676048zM7.30322465 18.4622255L5.29806761 21.2216273 7.30322465 18.4622255zM18.7007 2.77837273L16.6745917 5.56735268 18.7007 2.77837273z"
      />
      <polyline
        stroke="#46AAE9"
        strokeWidth="1.5"
        points="7.988 5.084 12 12.001 7.988 18.916"
      />
      <path
        stroke="#46AAE9"
        strokeWidth="1.5"
        d="M12,12.0006162 L19.9676339,12.0006162"
      />
    </g>
  </svg>
)
